// @spec POL-STR-013
'use client';

import { createFileRoute, Link } from '@tanstack/react-router';
import { ArrowLeft, Wand2 } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { WizardContainer } from '@/features/policies/wizard/WizardContainer';
import i18n from '@/lib/i18n';
import { useTranslation } from 'react-i18next';

export const Route = createFileRoute('/_authenticated/policies/wizard')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.aiDocumentWizard'),
  }),
  component: WizardPage,
});

function WizardPage() {
  const { t } = useTranslation('policies');
  return (
    <div className="container max-w-full px-6 py-6">
      {/* Header */}
      <div className="mb-6">
        <div className="mb-4">
          <Button variant="ghost" size="sm" asChild className="-ml-2">
            <Link to="/policies">
              <ArrowLeft className="mr-2 h-4 w-4" />
              {t('wizard.backToPolicies')}
            </Link>
          </Button>
        </div>
        <div className="flex items-center gap-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary/10">
            <Wand2 className="h-5 w-5 text-primary" />
          </div>
          <div>
            <h1 className="text-2xl font-semibold tracking-tight">{t('wizard.title')}</h1>
            <p className="text-sm text-muted-foreground">
              {t('wizard.subtitle')}
            </p>
          </div>
        </div>
      </div>

      {/* Wizard */}
      <WizardContainer />
    </div>
  );
}
